"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trim = void 0;
function trim(hexOrBytes) {
  let {
    dir = 'left'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
  let sliceLength = 0;
  for (let i = 0; i < data.length - 1; i++) {
    if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0') sliceLength++;else break;
  }
  data = dir === 'left' ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
  if (typeof hexOrBytes === 'string') {
    if (data.length === 1 && dir === 'right') data = "".concat(data, "0");
    return "0x".concat(data.length % 2 === 1 ? "0".concat(data) : data);
  }
  return data;
}
exports.trim = trim;
//# sourceMappingURL=trim.js.map